import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { Button } from 'reactstrap';
import MUIDataTable from 'mui-datatables';
import IconButton from '@mui/material/IconButton';
import MatButton from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';

import {
  getPendingContract,
  emailContractPending
} from 'Actions';


class ContractsPending extends Component {
  constructor(props) {
    super(props);
    this.confirmationDialog = React.createRef();
    this.state = {
      viewdiv: true,
    };
  }

  componentDidMount() {
    this.props.getPendingContract();
  }

  onSendEmail(ctid){
    this.props.emailContractPending(ctid).then((data) => {
      this.props.getPendingContract();
    });
  }

  render() {
    const { contractpendinglist, loading } = this.props;   

    const options = {
      filterType: 'dropdown',
      rowsPerPage: 50,
      responsive:'standard',
      rowsPerPageOptions: [50, 100, 150],
      selectableRowsHideCheckboxes: true,
    };

    const columns = [
      { name: 'sno', label: 'SNO.' },
      { name: 'student', label: 'STUDENT' },
      { name: 'agreementtype', label: 'AGREEMENT TYPE' },
      { name: 'executiondate', label: 'EXECUTION DATE' },
      { name: 'startdate', label: 'AGREEMENT START DATE' },
      { name: 'enddate', label: 'AGREEMENT END DATE' },
      { name: 'action', label: 'ACTION' },
    ];

    const tableData = contractpendinglist.map((data,index) => {
      if(data.ctsa_pendingemail==1){
        var shbtn='mr-10 mb-10 btn btn-info btn-sm text-white';
        var btl='Sent';
      }else{  
        var shbtn='mr-10 mb-10 btn btn-secondary btn-sm text-white';
        var btl='Send Email';
      } 

      const mailbtn=(
          <MatButton className={shbtn} onClick={() => this.onSendEmail(data.ctsaID)}>
            {btl}
          </MatButton>
      );

      return {
        sno: index + 1,
        student: data.studentname,
        agreementtype: data.agreementtype,
        executiondate: data.exdate,
        startdate: data.stdate,
        enddate: data.eddate,
        action:mailbtn,
      };
    });
    return (
      <div className="saas-dashboard">
        {this.state.viewdiv && (
          <div className="col-sm-12 col-lg-12">
            <MUIDataTable
              data={tableData}
              columns={columns}
              options={options}
            />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
    const { contractDashboard } = state;
    return {
      contractpendinglist: contractDashboard.contractpendinglist,
      loading: contractDashboard.loading,
    };
  };

export default connect(mapStateToProps, { getPendingContract, emailContractPending })(ContractsPending);
